export const initialReducerState = {
  onConfirmAction: null,
};
